import { api } from '..'

export const activateAlertRule = (alertRuleId: string) =>
  api.put(`/v1/alert-rules/${alertRuleId}/activate`)

export const deactivateAlertRule = (
  alertRuleId: string,
  resolveActiveAlerts: boolean,
) =>
  api.put(`/v1/alert-rules/${alertRuleId}/deactivate`, {
    resolveActiveAlerts,
  })
